import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import SkillAddEditDialog from './components/SkillAddEditDialog';
import { useDeleteSkillMutation } from 'src/app/services/skillApi';
import { useGetAllSkillQuery } from 'src/app/services/skillApiGet';

import useMessage from 'src/app/hooks/useMessage';
import FuseLoading from '@fuse/core/FuseLoading';
import Skill from './components/Skill';

const Skills = () => {
  const { t, i18n } = useTranslation('translations');
  const [isAddEditDialogVisible, setIsAddEditDialogVisible] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const { showMessage } = useMessage();
  const { data: skillsList, refetch, isLoading } = useGetAllSkillQuery();
  const [deleteSkill] = useDeleteSkillMutation();

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  const showEditSkillDialog = (skill) => {
    setSelectedSkill(skill);
    setIsAddEditDialogVisible(true);
  };

  const handleRemoveSkill = (skill) => {
    deleteSkill({ skillId: skill.id })
      .then((res) => {
        if (res) {
          showMessage({
            message: t('SuccessfullyDeleted'),
            variant: 'success',
          });
          refetch();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddEditDialogClose = () => {
    setSelectedSkill(null);
    setIsAddEditDialogVisible(false);
  };

  return (
    <div className="h-full  bg-white dark:bg-dark">
      <div className="h-64 pl-12 flex justify-between items-center">
        <h1 className="text-24 md:text-28 tracking-tight leading-none">{t('Skills')}</h1>
        <Button
          className="mx-8"
          size="small"
          variant="outlined"
          color="secondary"
          onClick={showEditSkillDialog}
        >
          <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
          <span className="mx-8">{t('Add')}</span>
        </Button>
      </div>
      <div className="flex flex-wrap gap-5 px-10">
        {isLoading && <FuseLoading />}
        {skillsList &&
          skillsList
            .toReversed()
            .map((skill) => (
              <Skill
                key={skill.id}
                skill={skill}
                onEdit={showEditSkillDialog}
                onRemove={() => handleRemoveSkill(skill)}
              />
            ))}
      </div>
      <SkillAddEditDialog
        skill={selectedSkill}
        isOpen={isAddEditDialogVisible}
        onClose={handleAddEditDialogClose}
        refetch={refetch}
      />
    </div>
  );
};

export default Skills;
